import service from "./service";

const getVendorDashboard = (date = "monthly") =>
  service.get(`vendors/dashboard?date=${encodeURIComponent(date)}`);

const vendorDashboardService = { getVendorDashboard };
export default vendorDashboardService;
